import { makeStyles } from "@material-ui/core/styles"
import NavigationItem from "components/NavigationItem"
import React, { memo } from "react"
import { HELP_LINK } from "app/api/config"
import NavigationExternalLink from "components/NavigationItem/NavigationExternalLink"
import { IconWrap, StyledDrawer, StyledList, StyledDocketIcon, StyledQuestionMarkIcon } from "./style"

type TNavItem = {
  name: string
  to: string
  icon: any
}

const useStyles = makeStyles(theme => ({
  drawerPaper: {
    backgroundColor: theme.palette.primary.main,
    borderRight: "none",
    width: "9rem",
  },
}))

interface IDrawer {
  navigationItems: TNavItem[]
}

function Drawer({ navigationItems }: IDrawer) {
  const classes = useStyles()

  return (
    <StyledDrawer variant="permanent" anchor="left" classes={{ paper: classes.drawerPaper }}>
      <IconWrap>
        <StyledDocketIcon />
      </IconWrap>
      <StyledList component="nav">
        {navigationItems.map(({ name, to, icon }, index) => (
          <NavigationItem key={name} to={to} name={name} icon={icon} index={index} />
        ))}
      </StyledList>
      <NavigationExternalLink
        icon={<StyledQuestionMarkIcon />}
        label="navigationitem.help"
        to={HELP_LINK}
        key="navigationItem.help"
      />
    </StyledDrawer>
  )
}

export default memo(Drawer)
